import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import {UserState, AUTH_WINDOW_CHANGE_EVENT, AUTH_CHANGE_EVENT} from './state';
import {InfoMessage} from '../components/infoMessage';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const AUTH_MISSING_USER_TXT = 'Lūdzu ievadiet lietotājvārdu';
const AUTH_MISSING_PASS_TXT = 'Lūdzu ievadiet paroli';


const styles = theme => ({
  TextField: {width: '174px'}
});

class User extends React.Component { // eslint-disable-line
	constructor(){
		super();

		this.state = {
      open: false,
      submit_btt_state: true,
      password: '',
      username: '',
      message: null,
    };
	}
componentDidMount(){
	
  UserState.on(AUTH_WINDOW_CHANGE_EVENT, () => {

    this.setState({password: '', username: '', open: UserState.getAuthWindowState()});
  });

  UserState.on(AUTH_CHANGE_EVENT, () => {

    this.setState({password: '', username: '', open: UserState.getAuthWindowState(), message: UserState.getMessage()});
  });

  document.onkeypress = function(e) {
    if (!e) e = window.event;
    var keyCode = e.keyCode || e.which;
    if (keyCode == '13') {
      // Enter pressed
      return false;
    }
  }
}
 handleAuth() {

    if(this.state.username == '') {

      this.setState({ message: AUTH_MISSING_USER_TXT});

      return;
    }

    if(this.state.password == '') {

      this.setState({ message: AUTH_MISSING_PASS_TXT});

      return;
    }

    UserState.login({username: this.state.username, password: this.state.password});
  }

  handleClose() {

    UserState.setAuthWindow(false);
  }

  handleUserInput(ev, newvalue) {

    this.setState({username: ev.target.value})

    this.submitBttEnableCheck();
  }
  handlePassInput(ev, newvalue) {

    this.setState({password: ev.target.value})

    this.submitBttEnableCheck();
  }
  submitBttEnableCheck() {
    if(this.state.username.length > 0 && this.state.password.length > 0) {
      if(!this.state.submit_btt_state){
        this.setState({submit_btt_state: true});
      }
      
    } else {
      if(this.state.submit_btt_state){
        this.setState({submit_btt_state: true}); //false
      }
    }
  }
  handleKeyDown(event) {

    if(event.key === 'Enter' && this.state.password.length > 0 && this.state.username.length > 0) {

        this.handleAuth();
    }
  }
  render() {
    
    var {classes} = this.props;

    return (
    	<Dialog
          modal={false}
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          style={{padding: '25px', fontSize:'1.2em'}}
        >
        <DialogTitle id="alert-dialog-title">{"Autorizācija"}</DialogTitle>
        <DialogContent>
          {this.state.message ? (<InfoMessage color="rgb(117, 47, 47)" message={this.state.message} />) : ''}
          <div style={{display:'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
            <div>
              <TextField
                className={classes.TextField}
                label="Lietotājvārds"
                onChange={this.handleUserInput.bind(this)}
                value={this.state.username}
                onKeyDown={this.handleKeyDown.bind(this)}
              /><br />
              <TextField
                className={classes.TextField}
                label="Parole"
                type="password"
                onChange={this.handlePassInput.bind(this)}
                value={this.state.password}
                onKeyDown={this.handleKeyDown.bind(this)}
              />
            </div>
            
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined" color="primary"
            onClick={this.handleClose.bind(this)}
          >Atcelt</Button>
          <Button
            variant="outlined" color="primary"
            disabled={!this.state.submit_btt_state}
            onClick={this.handleAuth.bind(this)}
          >Autorizēties</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
    name: 'Skolēni',
    menuItems: state.studentsMenu,
    mapPadding: state.map.padding
  }
}

const Comp = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(withStyles(styles)(User));

export default Comp;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/user/container.js